import { useQuery } from '@tanstack/react-query'
import { gameBoxRoomDetailService } from '../../../../services/games/games-boxes-rooms-details'
import type { GetCount } from '../../../../services/games/games-boxes-rooms-details/types'

export const GAMES_BOXES_ROOMS_DETAILS_QUERY_KEY =
  'getGamesBoxesRoomsDetailsCount'

export const useGetGamesBoxesRoomsDetailsCount = (params: GetCount.Input) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [GAMES_BOXES_ROOMS_DETAILS_QUERY_KEY, params],
    queryFn: () => {
      return gameBoxRoomDetailService.getCount(params)
    },
  })

  return {
    gamesBoxesRoomsDetailsCount: data?.data,
    isLoading,
    refetch,
  }
}
